import { Card } from "antd";
import { ReactNode } from "react";
import UserIcon from "../../../../assets/icons/UserIcon";
import CustomModal from "../../../../components/ui/CustomModal";
import { formatDate, formatTime } from "../../../../lib/time";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
> {
  open: boolean;
  action?: boolean;
  buttonBgDeep?: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: DataT;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;

  loading?: boolean;
  children?: ReactNode;
  batchLogData?: any;
}

export default function ViewPaymentLogModal({
  title,
  action,
  buttonName,
  buttonBgDeep,
  subTitle,

  handleClose,
  children,
  type,
  data,
  loading,
  batchLogData,
  ...rest
}: ModalConfirmProps) {
  const allData = batchLogData?.data;

  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={440}
        footer={null}
      >
        <Card>
          <div className="self-stretch justify-center text-slate-500 text-xl font-semibold mb-6">
            Batch Activity Log
          </div>
          <div className="mt-1 space-y-4">
            {allData.map((log: any, index: any) => (
              <div key={index} className="relative pl-6">
                {index !== log?.length - 1 && (
                  <div className="absolute left-2 top-0 w-0.5 h-full border-l-2 border-[#AFBACA] border-dashed"></div>
                )}

                <div
                  className={`absolute left-0 w-4 h-4 rounded-full ${
                    statusColors[log?.status as keyof typeof statusColors]
                  }`}
                ></div>

                <div className="text-[12px] ml-3">
                  <div className="font-semibold text-gray-600 text-[#C19C60]">
                    {formatTime(log?.created_at)} -{" "}
                    {formatDate(log?.created_at)}
                  </div>
                  {/* <p className="text-gray-700 text-display-body text-sm mb-1">
                    {log?.status?.charAt(0).toUpperCase() +
                      log?.status?.slice(1)}
                  </p> */}
                  <p className="text-gray-700 text-display-body text-sm mb-1">
                    {log?.remarks}
                  </p>
                  <div className="text-blue-500  flex items-center">
                    <div className="flex items-center gap-2">
                      <span className="text-[#FE7235] w-4 h-4 inline-flex items-center justify-center">
                        <UserIcon />
                      </span>
                      <span className="text-nowrap italic text-[#8897AE]">
                        {log?.user?.username} - {log?.status ? log?.status : ""}{" "}
                        - {log?.comment ? log?.comment : ""}
                      </span>
                    </div>
                    <span className="font-medium text-gray-600 ml-1 text-nowrap italic text-[#8897AE]">
                      {log.role}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </CustomModal>
    </>
  );
}

const statusColors = {
  approver: "bg-green-500",
  checker: "bg-yellow-400",
  maker: "bg-blue-500",
};
